import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_CREDENTIAL_DATA = 'SET_CREDENTIAL_DATA';
export const BULK_SET_CREDENTIALS_DATA = 'BULK_SET_CREDENTIALS_DATA';
export const SET_ACTIVE_FETCH = 'SET_ACTIVE_FETCH';
export const DELETE_USER_CREDENTIALS = 'DELETE_USER_CREDENTIALS';
export const UPDATE_CONNECTION_TEST = 'UPDATE_CONNECTION_TEST';
export const UPDATE_CREDENTIALS_NAME = 'UPDATE_CREDENTIALS_NAME';
export const SET_ALL_CREDENTIALS_DATA = 'SET_ALL_CREDENTIALS_DATA';
export const SET_CREDENTIALS_SUGGESTIONS = 'SET_CREDENTIALS_SUGGESTIONS';
export const SET_PROJECT_CREDENTIALS_DATA = 'SET_PROJECT_CREDENTIALS_DATA';
export const SET_LOCKED_CREDENTIALS = 'SET_LOCKED_CREDENTIALS';
export const SET_USER_MATCHING_DATA = 'SET_USER_MATCHING_DATA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_CREDENTIAL_DATA](state, payload) {
		const { key, value } = payload;
		Vue.set(state.data, key, value);
	},
	[BULK_SET_CREDENTIALS_DATA](state, { data }) {
		Vue.set(state, 'data', { ...state.data, ...data });
	},
	[SET_ALL_CREDENTIALS_DATA](state, payload) {
		const { data } = payload;
		// override previous data if exists
		Vue.set(state, 'data', data);
	},
	[SET_PROJECT_CREDENTIALS_DATA](state, payload) {
		const { projectId, data } = payload;
		Vue.set(state.projectCredentials, projectId, data);
	},
	[SET_ACTIVE_FETCH](state, value) {
		Vue.set(state, 'activeFetch', value);
	},
	[DELETE_USER_CREDENTIALS](state, credsId) {
		Vue.delete(state.data, credsId);
	},
	[UPDATE_CONNECTION_TEST](state, payload) {
		const { id, response } = payload;
		Vue.set(state.data[id], 'error_message', response.errorJSON);
		Vue.set(state.data[id], 'status', response.newStatus);
	},
	[UPDATE_CREDENTIALS_NAME](state, payload) {
		const { id, name } = payload;
		Vue.set(state.data[id], 'connection_name', name);
	},
	[SET_CREDENTIALS_SUGGESTIONS](state, payload) {
		const { workflowId, suggestions } = payload;
		Vue.set(state.credentialsSuggestions, workflowId, suggestions);
	},
	[SET_LOCKED_CREDENTIALS](state, payload) {
		const { workflowId, credentialsData } = payload;
		Vue.set(state.lockedCredentialsData, workflowId, credentialsData);
	},
	[SET_USER_MATCHING_DATA](state, payload) {
		const { data, credentialsId } = payload;
		Vue.set(state.userMatching, credentialsId, data);
	},
};

export default mutations;
